// extracted by mini-css-extract-plugin
export default {"model":"Model_model__F6bVg","model__view":"Model_model__view__NXalw"};